import React, { useCallback } from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import EditBtn from 'components/EditBtn'
import DeleteBtn from 'components/DeleteBtn'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  CardActions,
  TablePagination,
  Grid,
} from '@material-ui/core'
import { boolStr } from 'helpers/utils'
import { formatDateTime } from 'common/usual'
import { deleteInviteTemplatePromise } from 'api/Util'

const WorkoutCategory = (props) => {
  const { data, page, onPageChange } = props

  const handleDeleteRecord = useCallback((id) => {
    if (!window.confirm('are you sure?')) return

    deleteInviteTemplatePromise(id)
      .then(() => window.location.reload())
  }, [])

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>URL</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {((data && data.rows) || []).map(record => (
                    <TableRow key={record.id} hover>
                      <TableCell>{record.id}</TableCell>
                      <TableCell>{record.type}</TableCell>
                      <TableCell>{record.title}</TableCell>
                      <TableCell>{record.url}</TableCell>
                      <TableCell>{boolStr(record.active)}</TableCell>
                      <TableCell>{formatDateTime(record.created_at)}</TableCell>
                      <TableCell>
                        <Grid container>
                          <Grid item xs={6}>
                            <EditBtn path={`/invite-templates/edit/${record.id}`} {...props} />
                          </Grid>
                          <Grid item xs={6}>
                            {/* <Delete className='cursor-pointer' onClick={() => { handleDeleteRecord(record.id) }} /> */}
                            <DeleteBtn onClick={() => { handleDeleteRecord(record.id) }} />
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={'flex-right'}>
        <TablePagination
          component="div"
          count={(data && data.count) || 0}
          onChangePage={onPageChange}
          page={page - 1}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
        />
      </CardActions>
    </Card>
  )
}

export default WorkoutCategory
